/**
 * CASL Ability Helpers
 *
 * Frontend helpers for creating abilities from serialized rules.
 *
 * @layer features
 * @slice authorization
 * @segment lib
 * @added DOC-0063 (2025-12-19)
 * @updated DOC-0095 (2025-12-26) - Migrated to FSD features/authorization
 */

import { createMongoAbility } from '@casl/ability';
import type { Actions, Subjects, AppAbility, AppAbilityRule } from '@shared/types/ability';

/**
 * Empty ability for unauthenticated users
 */
export const defaultAbility: AppAbility = createMongoAbility<[Actions, Subjects]>([]);

/**
 * Reconstruct ability from serialized rules
 */
export function createAbilityFromRules(rules: AppAbilityRule[]): AppAbility {
  return createMongoAbility<[Actions, Subjects]>(rules);
}
